import React, { useState } from 'react';

import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@mui/styles';
import {
  DialogTitle,
  IconButton,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
  Box,
  Dialog,
  Button,
  TextField,
  Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles((theme) => ({
  dialogContainer: {
    width: '460px',
  },
  dialogTitle: {
    fontSize: '18px',
    fontWeight: 500,
  },
  dialogText: {
    marginTop: 15,
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '18px',
  },
  dialogActions: {
    padding: '16px 24px',
  },
  buttonDisabled: {
    '&.MuiButton-contained.Mui-disabled': {
      opacity: 0.5,
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
  },
  icon: {
    position: 'absolute',
    right: 8,
    top: 2,
    color: theme.palette.grey[500],
  },
}));

const NoteDialog = ({
  data,
  open,
  onCloseModal,
  title,
  descr,
  secDescr,
  onSubmitNote,
  divider,
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const [note, setNote] = useState('');

  return (
    <>
      <Dialog open={open} onClose={() => onCloseModal(false)}>
        <Box className={classes.dialogContainer}>
          {title && (
            <>
              <DialogTitle>
                <Typography className={classes.dialogTitle}>
                  {t(title)}
                </Typography>
                {onCloseModal && (
                  <IconButton
                    onClick={() => onCloseModal(false)}
                    className={classes.icon}>
                    <CloseIcon />
                  </IconButton>
                )}
              </DialogTitle>
              <Divider />
            </>
          )}
          {descr && (
            <DialogContent>
              <DialogContentText className={classes.dialogText}>
                <Typography>{t(descr)}</Typography>
                {secDescr && (
                  <Typography style={{ marginTop: 24 }}>
                    {`${t(secDescr)}: `}
                    <strong>{data.order_number}</strong>
                  </Typography>
                )}
              </DialogContentText>
            </DialogContent>
          )}
          <DialogContent style={{ marginBottom: 30 }}>
            <TextField
              fullWidth
              rows={5}
              multiline={true}
              placeholder={t('session_note')}
              onChange={(e) => {
                setNote(e.target.value);
              }}
              variant="outlined"
            />
          </DialogContent>
          {divider && <Divider />}
          <Box
            style={{
              display: 'flex',
              justifyContent: 'end',
              alignContent: 'center',
            }}>
            <DialogActions className={classes.dialogActions}>
              <Button
                color="primary"
                variant="outlined"
                style={{ marginRight: 10 }}
                onClick={() => onCloseModal(false)}>
                {t('cancel')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                classes={{ disabled: classes.buttonDisabled }}
                disabled={isEmpty(note)}
                onClick={() => onSubmitNote(note)}>
                {t('submit')}
              </Button>
            </DialogActions>
          </Box>
        </Box>
      </Dialog>
    </>
  );
};

export default NoteDialog;
